import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { AuthService } from '../services/auth.service';

export const AuthGuard: CanActivateFn = async (route, state) => {

  const authService = inject(AuthService);

  const path = route.routeConfig?.path;
  if (['callback', 'logout', 'sessionexpired'].includes(path || '')) return true;

  if (authService.authState() === 'authenticating') {
    await authService.waitForAuthStabilization();
  }

  const hasValidSession = await authService.validateUserSession(false);
  if (hasValidSession) return true;

  if (authService.authState() === 'unauthenticated') {
    // Force renew tokens if not authenticated
    await authService.validateUserSession(true);
  }
  return authService.authState() === 'authenticated';
};
